<template>
  <div>
    <card-meal
      :title="name"
      :images-src="images">
      <card-meal-action-remove @click="showDislikesPopup"/>
    </card-meal>

  </div>
</template>
<script>
import CardMeal from '../../../../../global/cards/CardMeal'
import CardMealActionRemove from '../../../../../global/cards/card-meal-sub-components/CardMealActionRemove'
import lodash from 'lodash'

export default {
  name: 'card-meal-dilike',
  components: {
    CardMeal,
    CardMealActionRemove
  },
  props: {
    dislike: {}

  },
  computed: {
    images: function () {
      let imgs = []
      this.dislike.recipes.forEach(recipe => {
        if (recipe.images && recipe.images[0]) {
          imgs.push(recipe.images[0].url)
        }
      })
      imgs = imgs.slice(0, 3)
      let sortedImgs = lodash.sortBy(imgs)
      return sortedImgs
    },
    name: function () {
      return this.dislike.recipes[0].name +
        (this.dislike.recipes.length > 1
          ? ' + ' +
          (this.dislike.recipes.length - 1) +
          ' ' +
          this.$i18n.t('message[\'general.more-text\']')
          : '')
    }
  },
  methods: {
    showDislikesPopup () {
      this.$emit('delete', true)
    }
  }
}
</script>
